const styles = theme => ({
  container: {
    background: theme.palette.secondary.breadcrumbBackground,
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    position: 'relative',
    backdropFilter: 'blur(4.5px)',
  },
  fadedContainer: {
    background: '#FFFFFF',
    // boxShadow: '0 0 0 100vmax rgba(204, 203, 206,0.7)',
    position: 'relative',
    // backdropFilter: 'blur(5px)',
    zIndex: 1,
    // [theme.breakpoints.up('sm')]: {
    //   boxShadow: '0 0 0 100vmax rgba(0,0,0,0.3)',
    //   zIndex: 1,
    // },
  },
  navBarContainer: {
    [theme.breakpoints.down('sm')]: {
      // height: '30px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '38px',
    },
  },
  navBarStepperContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      height: '38px',
      display: 'block',
    },
  },
  leftButton: {
    display: 'flex',
    justifyContent: 'start',
    height: { xs: 24, md: 'fit-content' },
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'start',
      marginLeft: '1rem',
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: '1.5rem',
    },
  },
  rightButton: {
    display: 'flex',
    justifyContent: 'end',
    height: { xs: 24, md: 'fit-content' },
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'end',
      marginRight: '1rem',
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: '1.5rem',
    },
  },
  disableButton: {
    visibility: 'hidden',
  },
  backButtonText: {
    textTransform: 'none',

    ml: 1,
    color: theme.palette.primary.contrastText,
  },
  nextButtonText: {
    textTransform: 'none',

    mr: 1,
    color: theme.palette.primary.contrastText,
  },
});

export default styles;
